import { Fragment, FunctionComponent, useState } from 'react'
import { SectionGroup } from '@/types/Section'
import styles from './staffRate.module.scss'
import { TableCell, TableRow } from '@mui/material'
import { Delete } from '@mui/icons-material'
import { Daycare } from '@/types/Daycare'
import EditIcon from '@mui/icons-material/Edit'
import { useTranslation } from 'react-i18next'
import StaffRateForm from './Form/staffRateForm'
import Desktop from '@/modules/desktopMobile/desktop'
import { useDialog } from '@/hooks/useDialog/useDialog'
import ConfirmDeleteStaffRate from './Form/confirmDeleteStaffRate'

interface StaffRateRowProps {
    sectionGroup: SectionGroup
    daycare: Daycare
    canUpdate: boolean
    refetchStaffRates: () => void
}

const StaffRateRow: FunctionComponent<StaffRateRowProps> = ({
    sectionGroup,
    daycare,
    canUpdate,
    refetchStaffRates
}: StaffRateRowProps) => {
    const { t } = useTranslation()
    const [staffRateName, setStaffRateName] = useState<string>(sectionGroup?.name || '')
    const [staffRate, setStaffRate] = useState<string>(sectionGroup?.rate.toString() || '')
    const [sections, setSections] = useState<Array<string>>(
        sectionGroup?.sections.map((section) => section.toString()) || []
    )

    const sectionGroupId: number = sectionGroup.id

    const { dialog: manageStaffRateDialog, openDialog: openManageStaffRate } = useDialog({
        dialogTitle: t('addStaffRate'),
        Component: StaffRateForm,
        props: (handleClose) => ({
            handleClose,
            create: false,
            staffRateId: sectionGroupId,
            staffRateName,
            setStaffRateName,
            staffRate,
            setStaffRate,
            staffRateSections: sections,
            setStaffRateSections: setSections,
            refetchStaffRates,
            daycare
        }),
        hideDialogClose: true
    })

    const { dialog: deleteStaffRateDialog, openDialog: openDeleteStaffRate } = useDialog({
        dialogTitle: t('confirmDeleteStaffRate'),
        Component: ConfirmDeleteStaffRate,
        props: (handleClose) => ({
            handleClose,
            sectionGroupId,
            daycareId: daycare.id,
            refetchStaffRates
        }),
        hideDialogClose: true
    })

    return (
        <>
            <TableRow>
                <TableCell>{staffRateName}</TableCell>
                <Desktop>
                    <TableCell>{staffRate}</TableCell>
                    <TableCell className={styles.RowBorder}>
                        {sections.length === 0
                            ? t('noSections')
                            : daycare.sections &&
                              daycare.sections.map((section, index) => (
                                  <Fragment key={index}>
                                      {sections.includes(section.id.toString()) && <li>{section.name}</li>}
                                  </Fragment>
                              ))}
                    </TableCell>
                </Desktop>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={openManageStaffRate} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={openDeleteStaffRate} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            {deleteStaffRateDialog}
            {manageStaffRateDialog}
        </>
    )
}

export default StaffRateRow
